import axios from 'axios';
import Urls from '../config/urls';

const Ajax = (() => {

    const get = (url, onSuccess, onError) => axios.get(url).then(onSuccess).catch(processError(onError));

    const post = (url, data, onSuccess, onError) => axios.post(url, data).then(onSuccess).catch(processError(onError));

    const checkError = (error, errorCode) => error.response && error.response.status === errorCode;

    const processError = (onError) => (error) => {
        if (checkError(error, 400)) {
            console.log("400 Error Code received");
        }
        onError(error);
    };

    const getAllPeople = (onSuccess, onError) => Urls.then(x => get(x.getAllPeople, onSuccess, onError));

    const getAllOwners = (onSuccess, onError) => Urls.then(x => get(x.getAllOwners, onSuccess, onError));

    const getProductionRoleByID = (id, onSuccess, onError) => Urls.then(x => get(x.getProductionRoleByID(id), onSuccess, onError));

    const createRole = (data, onSuccess, onError) => Urls.then(x => post(x.createRole, data, onSuccess, onError));

    const getPendingRoles = (data, onSuccess, onError) => Urls.then(x => post(x.getPendingRoles, data, onSuccess, onError));

    const getRolesForPgApproval = (data, onSuccess, onError) => Urls.then(x => post(x.getRolesForPgApproval, data, onSuccess, onError));

    const getRolesByStatus = (data, onSuccess, onError) => Urls.then(x => post(x.getRolesByStatus, data, onSuccess, onError));

    const getApprovedStatusRoles = (data, onSuccess, onError) => Urls.then(x => post(x.getApprovedStatusRoles, data, onSuccess, onError));

    const assignPGsToRole = (data, onSuccess, onError) => Urls.then(x => post(x.assignPGsToRole, data, onSuccess, onError));

    const updateRoleAdditionalApproversCISO = (data, onSuccess, onError) => Urls.then(x => post(x.updateRoleAdditionalApproversCISO, data, onSuccess, onError));

    const updateRoleAdditionalApproversOwner = (data, onSuccess, onError) => Urls.then(x => post(x.updateRoleAdditionalApproversOwner, data, onSuccess, onError));

    const updateRoleAdditionalApproversPgOwner = (data, onSuccess, onError) => Urls.then(x => post(x.updateRoleAdditionalApproversPgOwner, data, onSuccess, onError));

    const getAllPGs = (onSuccess, onError) => Urls.then(x => get(x.getAllPGs, onSuccess, onError));

    const assignEmployeesToRole = (data, onSuccess, onError) => Urls.then(x => post(x.assignEmployeesToRole, data, onSuccess, onError));

    const getAssignedImportantRoles = (onSuccess, onError) => Urls.then(x => get(x.getAssignedImportantRoles, onSuccess, onError));

    const getAssignedRolesForAdditionalApproval = (data, onSuccess, onError) => Urls.then(x => post(x.getAssignedRolesForAdditionalApproval, data, onSuccess, onError));

    const getProductionRoles = (data, onSuccess, onError) => Urls.then(x => post(x.getProductionRoles, data, onSuccess, onError));

    const cisoApproveRole = (data, onSuccess, onError) => Urls.then(x => post(x.cisoApproveRole, data, onSuccess, onError));

    const additionalApproveRole = (data, onSuccess, onError) => Urls.then(x => post(x.additionalApproveRole, data, onSuccess, onError));

    const edit = (data, onSuccess, onError) => Urls.then(x => post(x.edit, data, onSuccess, onError));

    const removeEmployee = (data, onSuccess, onError) => Urls.then(x => post(x.removeEmployee, data, onSuccess, onError));

    const generateReports = (onSuccess, onError) => Urls.then(x => get(x.generateReportsURL, onSuccess, onError));

    const getRelatedPermissionGroups = (id, onSuccess, onError) => Urls.then(x => get(x.getRelatedPermissionGroups(id), onSuccess, onError));

    const generateInactiveAccsReports = (onSuccess, onError) => Urls.then(x => get(x.generateInactiveAccsReportURL, onSuccess, onError));

    const generateAllUserAccsReports = (onSuccess, onError) => Urls.then(x => get(x.generateAllUserAccsReportURL, onSuccess, onError));

    const generateUsersWithoutRolesReports = (onSuccess, onError) => Urls.then(x => get(x.generateUsersWithoutRolesReportURL, onSuccess, onError));

    const generatePgChangePerUserReports = (totalLines, onSuccess, onError) => Urls.then(x => get(x.generatePgChangePerUserURL(totalLines), onSuccess, onError));

    const generateUnmatchedEmployeesReports = (onSuccess, onError) => Urls.then(x => get(x.generateUnmatchedEmployeesReportsURL, onSuccess, onError));

    const generatePasswordNeverExpiresReport = (onSuccess, onError) => Urls.then(x => get(x.generatePasswordNeverExpiresReportURL, onSuccess, onError));

    const generateGCPReport = (onSuccess, onError) => Urls.then(x => get(x.generateGCPReportsURL, onSuccess, onError));

    const generatePGsWithoutDescriptionReport = (onSuccess, onError) => Urls.then(x => get(x.generatePGsWithoutDescriptionReportURL, onSuccess, onError));

    const getLoggedInUser = (onSuccess, onError) => Urls.then(x => get(x.getLoggedInUser, onSuccess, onError));

    const logout = (onSuccess, onError) => Urls.then(x => post(x.logout, onSuccess, onError));

    const getAllRoles = (onSuccess, onError) => Urls.then(x => get(x.getAllRoles, onSuccess, onError));

    const updateRoleOwner = (data, onSuccess, onError) => Urls.then(x => post(x.updateRoleOwner, data, onSuccess, onError));

    const updatePgOwner = (data, onSuccess, onError) => Urls.then(x => post(x.updatePgOwner, data, onSuccess, onError));

    const getPermissionGroupsPerRole = (id, onSuccess, onError) => Urls.then(x => get(x.getPermissionGroupsPerRole(id), onSuccess, onError));

    const getManagerSystems = (managerId, onSuccess, onError) => Urls.then(x => get(x.getManagerSystems(managerId), onSuccess, onError));

    const getManagerEmployeesForQar = (managerId, onSuccess, onError) => Urls.then(x => get(x.getManagerEmployeesForQar(managerId), onSuccess, onError));

    const getMyManagers = (managerId, onSuccess, onError) => Urls.then(x => get(x.getMyManagers(managerId), onSuccess, onError));

    const getAllSnpManagers = (currentComplianceReviewId, onSuccess, onError) => Urls.then(x => get(x.getAllSnpManagers(currentComplianceReviewId), onSuccess, onError));

    const getAllActiveSnpEmployees = (currentComplianceReviewId, onSuccess, onError) => Urls.then(x => get(x.getAllActiveSnpEmployees(currentComplianceReviewId), onSuccess, onError));

    const getAllManagers = (onSuccess, onError) => Urls.then(x => get(x.getAllManagers(), onSuccess, onError));

    const saveManagerReview = (data, onSuccess, onError) => Urls.then(x => post(x.saveManagerReview, data, onSuccess, onError));

    const editManagerReview = (data, onSuccess, onError) => Urls.then(x => post(x.editManagerReview, data, onSuccess, onError));

    const getAllSystemsForReview = (complianceReviewId, onSuccess, onError) => Urls.then(x => get(x.getAllSystemsForReview(complianceReviewId), onSuccess, onError));

    const sendSOXEmails = (data, onSuccess, onError) => Urls.then(x => post(x.sendSOXEmails, data, onSuccess, onError));

    const getAllManagersByAccountId = (accountId, complianceReviewId, onSuccess, onError) => Urls.then(x => get(x.getAllManagersByAccountId(accountId, complianceReviewId), onSuccess, onError));

    const getEmployeesByManagerReviewId = (reviewId, accountId, complianceReviewId, onSuccess, onError) => Urls.then(x => get(x.getEmployeesByManagerReviewId(reviewId, accountId, complianceReviewId), onSuccess, onError));

    const saveSoxComment = (data, onSuccess, onError) => Urls.then(x => post(x.saveSoxComment, data, onSuccess, onError));

    const getAllEmployeesByAccountId = (accountId, complianceReviewId, onSuccess, onError) => Urls.then(x => get(x.getAllEmployeesByAccountId(accountId, complianceReviewId), onSuccess, onError));

    const getGroupsByRoleAndAccount = (roleId, accountId, onSuccess, onError) => Urls.then(x => get(x.getGroupsByRoleAndAccount(roleId, accountId), onSuccess, onError));

    const getAccountsSyncStatus = (onSuccess, onError) => Urls.then(x => get(x.getAccountsSyncStatus, onSuccess, onError));

    const getChameleonAdminsEmployeeReviewsPerAccount = (accountId, complianceReviewId, onSuccess, onError) => Urls.then(x => get(x.getChameleonAdminsEmployeeReviewsPerAccount(accountId, complianceReviewId), onSuccess, onError));

    const getAllFindingsForAllAccounts = (complianceReviewId, onSuccess, onError) => Urls.then(x => get(x.getAllFindingsForAllAccounts(complianceReviewId), onSuccess, onError));

    const getAllFindingsByAccountId = (accountId, complianceReviewId, onSuccess, onError) => Urls.then(x => get(x.getAllFindingsByAccountId(accountId, complianceReviewId), onSuccess, onError));

    const getAllDelegatedEmployeesByAccountId = (accountId, complianceReviewId, onSuccess, onError) => Urls.then(x => get(x.getAllDelegatedEmployeesByAccountId(accountId, complianceReviewId), onSuccess, onError));

    const setManagerReviewsAsCompleted = (quarter, year, userId, onSuccess, onError) => Urls.then(x => get(x.setManagerReviewsAsCompleted(quarter, year, userId), onSuccess, onError));

    const getAllDataCenters = (onSuccess, onError) => Urls.then(x => get(x.getAllDataCenters, onSuccess, onError));

    const delegateEmployeesFromAdminPanel = (data, onSuccess, onError) => Urls.then(x => post(x.delegateEmployeesFromAdminPanel, data, onSuccess, onError))

    const getUnmatchedAccounts = (snpAccountId, onSuccess, onError) => Urls.then(x => get(x.getUnmatchedAccounts(snpAccountId), onSuccess, onError))

    const getAllUnmatchedAccounts = (onSuccess, onError) => Urls.then(x => get(x.getAllUnmatchedAccounts(), onSuccess, onError))

    const getSnpUnmatchedAccounts = (snpAccountId, complianceReviewId, onSuccess, onError) => Urls.then(x => get(x.getSnpUnmatchedAccounts(snpAccountId, complianceReviewId), onSuccess, onError))

    const setResponsibleManager = (data, onSuccess, onError) => Urls.then(x => post(x.setResponsibleManager, data, onSuccess, onError))

    const getReviewHistoryByManagerReviewId = (managerReviewId, accountId, onSuccess, onError) => Urls.then(x => get(x.getReviewHistoryByManagerReviewId(managerReviewId, accountId), onSuccess, onError));

    const getComplianceReviews = (onSuccess, onError) => Urls.then(x => get(x.getComplianceReviews(), onSuccess, onError));

    return {
        getAllPeople,
        getProductionRoleByID,
        getPendingRoles,
        getRolesByStatus,
        getRolesForPgApproval,
        getApprovedStatusRoles,
        createRole,
        assignPGsToRole,
        updateRoleAdditionalApproversCISO,
        updateRoleAdditionalApproversOwner,
        updateRoleAdditionalApproversPgOwner,
        getAllPGs,
        assignEmployeesToRole,
        getAssignedImportantRoles,
        getAssignedRolesForAdditionalApproval,
        cisoApproveRole,
        additionalApproveRole,
        getProductionRoles,
        edit,
        removeEmployee,
        generateReports,
        generateInactiveAccsReports,
        generateAllUserAccsReports,
        generateUsersWithoutRolesReports,
        generatePgChangePerUserReports,
        generateUnmatchedEmployeesReports,
        generatePasswordNeverExpiresReport,
        generateGCPReport,
        generatePGsWithoutDescriptionReport,
        getRelatedPermissionGroups,
        getAllOwners,
        getLoggedInUser,
        logout,
        getAllRoles,
        updateRoleOwner,
        updatePgOwner,
        getPermissionGroupsPerRole,
        getManagerSystems,
        getManagerEmployeesForQar,
        getMyManagers,
        getAllSnpManagers,
        getAllActiveSnpEmployees,
        getAllManagers,
        saveManagerReview,
        editManagerReview,
        getAllSystemsForReview,
        sendSOXEmails,
        getAllManagersByAccountId,
        getEmployeesByManagerReviewId,
        saveSoxComment,
        getAllEmployeesByAccountId,
        getGroupsByRoleAndAccount,
        getAccountsSyncStatus,
        getChameleonAdminsEmployeeReviewsPerAccount,
        getAllFindingsForAllAccounts,
        getAllFindingsByAccountId,
        getAllDelegatedEmployeesByAccountId,
        setManagerReviewsAsCompleted,
        getAllDataCenters,
        delegateEmployeesFromAdminPanel,
        getUnmatchedAccounts,
        getAllUnmatchedAccounts,
        getSnpUnmatchedAccounts,
        setResponsibleManager,
        getReviewHistoryByManagerReviewId,
        getComplianceReviews,
    }
})();

export default Ajax;